import React from "react";
import styled from "styled-components";

const FormGroup = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  :not(:last-of-type) {
    margin-bottom: 0.5rem;
  }
`;

const Checkbox = styled.input`
  margin-right: 0.5rem;
  cursor: pointer;
`;

const Label = styled.label`
  cursor: pointer;
`;

const CheckboxComponent = ({ label, selected, onCheckboxChanged }) => {
  return (
    <FormGroup>
      <Checkbox
        type="checkbox"
        checked={selected}
        id={label}
        onChange={() => onCheckboxChanged(label)}
      />
      <Label for={label}>{label}</Label>
    </FormGroup>
  );
};

export default CheckboxComponent;



// WEBPACK FOOTER //
// ./src/components/UI/Checkbox.js